import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { FEED_OPTIONS, getEnabledFeedOptions, isFeedOptionAvailable } from "%/dynamic-component-editor/constants/feed-options";
import { camelToTitleCase } from "@bloglovin/vue-framework";

const OPTION_KEY = "smart-feed-selection";

export default class SmartFeedSelection extends BaseOption {
  static userInterfaceComponent = optionValues => {
    const availableFeedOptions = getEnabledFeedOptions();
    const currentSource = optionValues?.[`default.${OPTION_KEY}`];

    const options = Object.keys(availableFeedOptions)
        .filter(feed => !availableFeedOptions[feed].deprecated || feed === currentSource)
        .map(feed => ({
          id: feed,
          name: availableFeedOptions[feed].displayName || camelToTitleCase(feed, true),
          warning: availableFeedOptions[feed].deprecated ? availableFeedOptions[feed].deprecationWarning ?? "" : "",
        }));

    return {
      label: "Please select a feed",
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options,
      },
    };
  };

  static defaultValue = "";

  static convertConfigValueToCompiledValue(configValue) {
    // If you are replacing an existing feed-option
    if (!configValue) {
      return "";
    }

    if (!FEED_OPTIONS[configValue]) {
      return "";
    }

    if (FEED_OPTIONS[configValue].deprecated) {
      switch (configValue) {
        case "ExclusiveStories":
          return "HomeStories";
      }
    }

    if (!isFeedOptionAvailable(configValue)) {
      return "";
    }

    return configValue;
  }
}
